<template>
  <b-tab id="tab-attach-2" title="เอกสารประกอบเรื่องร้องเรียน">
    <b-card>
      <!-- search input -->
        <h3 class="">
            เอกสารรออนุมัติ
          </h3>
      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :line-numbers="true"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: No -->
          <!-- <span v-if="props.column.field === 'No'" class="text-nowrap" >
          <span class="text-nowrap">  1 </span>
        </span> -->

          <span v-if="props.column.field === 'docCode'" class="text-nowrap">
            <span class="text-nowrap"
              >{{ props.row.docCode }}
              <br />
              {{ props.row.complaintCode }}
            </span>
          </span>

          <span v-if="props.column.field === 'status'" class="text-nowrap">
            <span class="text-nowrap"
              ><a
                href="javascript:void(0);"
                @click="getDocHistory(props.row.docId)"
                >{{ props.row.statusname }}</a
              ></span
            >
          </span>

          <span v-if="props.column.field === 'file'" class="text-nowrap">
            <span class="text-nowrap">{{ props.row.description }}</span>
          </span>
          <span
            v-if="props.column.field === 'Complain_Date'"
            class="text-nowrap"
          >
            <span class="text-nowrap">{{ props.row.dateStr }}</span>
          </span>
          <span v-if="props.column.field === 'name'" class="text-nowrap">
            <span class="text-nowrap"
              >{{ props.row.fName }} {{ props.row.lName }}</span
            >
          </span>
          <!-- Column: Action -->
          <span v-else-if="props.column.field === 'action'">
            <b-button variant="primary" @click="getSuccess(props.row.docId)">
              ดูเอกสารคำขอ
            </b-button>
            <b-button
              v-if="props.row.lawConsultId !== null"
              variant="primary"
              @click="onDocumentLawConsultClicked(props.row.docId)"
            >
              คำปรึกษากฏหมาย
            </b-button>
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap ">
                แสดง 1 ถึง
              </span>
              <b-form-select
                v-model="pageLength"
                :options="['10', '50', '100']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card>

    <slot></slot>

    <ModalLawConsult ref="modal-law-consult"></ModalLawConsult>

    <ModalDocHistory
      ref="modal-doc-history"
      :docHistoryDetail="docHistoryDetail"
    ></ModalDocHistory>
    
  </b-tab>
</template>

<script>

import ModalLawConsult from './ModalLawConsult.vue'
import ModalDocHistory from './ModalDocHistory.vue'
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { VueGoodTable } from "vue-good-table";
import {
  BRow,
  BCol,
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BTab,
  BModal,
} from "bootstrap-vue";
import { codeBasic } from "@/views/table/vue-good-table/code";
import store from "@/store/index";
import Ripple from "vue-ripple-directive";
import * as viewStore from "@/store/api/approve/approve.js";
import TableHeaders from "./TrackingDetailTableHeader.js";
import appsettings from "@/store/app-settings";
import * as documentStore from "@/store/api/document/index.js";
import * as storeDocument from "@/store/api/document/index.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCardCode,
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    BTab,
    viewStore,
    ModalLawConsult,
    ModalDocHistory,
    BModal,
  },
  props: {
    complaintId: "",
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: TableHeaders,
      rows: [],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],

      docHistoryDetail: [],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    this.onSearchSubmit({});
  },
  methods: {
    getDocHistory(docId) {
        var _this = this;
        console.log("docId: ",docId)


        storeDocument
        .GetHistoryDocument(docId)
        .then((response) => {

          //console.log("docHistoryDetail:", response.data.data);

          _this.docHistoryDetail = response.data.data;

          //console.log('ref', _this.$refs)
          _this.$refs['modal-doc-history'].$refs['modal-doc-history'].show()
        })
        .catch((error) => {
          console.log("error", error);
        });
      },
    onSearchSubmit(params) {
      const _this = this;


      let redirectUrl1 = location.origin + this.$router.currentRoute.fullPath

      const data = {
        complaintId: this.$props.complaintId,
        authen: userData.userId(),
        redirectUrl:redirectUrl1,
        redirectBack:redirectUrl1,
      };

      console.log('get documentTrackingDetail', data)

      storeDocument
        .getDocumentTrackingDetail(data)
        .then((response) => {
          _this.rows = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getSuccess(docId) {
      // let redirectUrl =
      //   location.origin + this.$router.resolve({ name: "Approve" }).href;
      // let redirectBack =
      //   location.origin + this.$router.resolve({ name: "Approve" }).href;

        let redirectUrl = location.origin + this.$router.currentRoute.fullPath

      const documentUrl = appsettings.documentUrl
        .replace("{0}", docId)
        .replace("{1}", userData.userId())
        .replace("{2}", redirectUrl)
        .replace("{3}", redirectUrl);

      //window.location.href = documentUrl;

      window.open(documentUrl, "_blank");
    },
    onDocumentUrlClicked(documentUrl) {
      window.open(documentUrl, "_blank");
    },

    onDocumentLawConsultClicked(documentId) {
      this.$refs["modal-law-consult"].$refs["modal-law-consult"].show();

      this.$refs["modal-law-consult"].onShow(documentId);
    }
  },
};
</script>

<style></style>
